import ReactDOM from 'react-dom/client';
import App from './App';
import React from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './views/includes/authConfig';
import { Provider } from 'react-redux';
import store from 'apps/store';
import { BrowserRouter } from "react-router-dom";

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
export const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <MsalProvider instance={msalInstance}>
    <BrowserRouter basename={"/"}>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </MsalProvider>
);
